export const uk = {
    'Selected-of-regions': 'Выбрано {currentRegionCount} из {totalRegionCount} городов',
    'all-city': 'Все города',
    'delete-screens': 'Удалить экраны',
    'many-screens': '{count} экранов',
    'many-uncheck-confirm-message': 'Вы собираетесь удалить {count} экранов в городе {city} из списка выбранных.',
    'one-screens': '{count} экран',
    'one-uncheck-confirm-message': 'Вы собираетесь удалить {count} экран в городе {city} из списка выбранных.',
    'show-on-map': 'Показать на карте',
    'some-screens': '{count} экрана',
    'some-uncheck-confirm-message': 'Вы собираетесь удалить {count} экрана в городе {city} из списка выбранных.'
};
